import { Toaster as Sonner } from 'sonner';

/**
 * Toasts at the top, clear of the iPhone status bar and Dynamic Island (the home-screen app draws under them:
 * viewport-fit=cover and a translucent status bar), in the page's theme tokens.
 *
 * Sonner's own styles are not in a cascade layer, so they beat Tailwind's utilities: its colours are set through its
 * variables (--normal-*) on each toast, and every other override is marked important (!).
 */
export function Toaster() {
  return (
    <Sonner
      position="top-center"
      closeButton
      // Sonner's defaults (24 px, and 16 px under 600 px wide) ignore the safe area.
      offset={{ top: 'max(24px, calc(env(safe-area-inset-top) + 16px))' }}
      mobileOffset={{ top: 'max(16px, calc(env(safe-area-inset-top) + 8px))' }}
      toastOptions={{
        classNames: {
          // pe-12 keeps the text clear of the close button.
          toast: '[--normal-bg:var(--surface)] [--normal-border:var(--border)] [--normal-text:var(--fg)] pe-12! shadow-xl!',
          description: 'text-muted!',
          // A 44 px target inside the toast's top end corner, in place of sonner's 20 px circle astride the corner.
          closeButton: [
            'start-auto! end-1! top-1! size-tap! transform-none! rounded-lg! border-0! bg-transparent! text-muted!',
            'hover:bg-surface-2! hover:text-fg! focus-visible:outline-2 focus-visible:outline-accent [&_svg]:size-4',
          ].join(' '),
          error: 'border-loss/50!',
          success: 'border-gain/50!',
          warning: 'border-warn/50!',
        },
      }}
    />
  );
}
